import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ExportButton from '../../common/components/export-button';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    widgetContainer: {
        height: '100%',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px 0`,
    },
    widgetContent: {
        display: 'contents',
    },
    widgetHeader: {
        padding: '0 0 16px 0',
    },
} );


const Widget = ( { classes, widgetDetails, content, exportToCSV, config: { subtitle = '' } } ) => {

    const dataAutomationId = widgetDetails.name.replace( / /g, '-' ).toLowerCase();
    return (
        <Card className={classes.widgetContainer} data-automation-id={`${dataAutomationId}-widget`}>
            <CardHeader
                action={
                    widgetDetails.exportable && ( <ExportButton
                        automationId={`${dataAutomationId}-export-button`}
                        exportType={exportToCSV}
                        exportText="Export to CSV"
                    /> )
                }
                classes={{ root: classes.widgetHeader }}
                title={<Typography variant="h6">{widgetDetails.name}</Typography>}
                subheader={<Typography variant="subtitle1" color="textSecondary">{subtitle}</Typography>}
            />
            <CardContent classes={{ root: classes.widgetContent }}>
                {content}
            </CardContent>
        </Card>
    );
};

Widget.propTypes = {
    classes: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
    exportToCSV: PropTypes.func,
    widgetDetails: PropTypes.object.isRequired,
};

export default withStyles( styles )( Widget );
